export enum ENotificationTemplate {
  NT_ORDER_CREATE = 'NT_ORDER_CREATE',
  NT_ORDER_PENDING_CREATE = 'NT_ORDER_PENDING_CREATE',
  NT_ORDER_PENDING_TRIGGERED = 'NT_ORDER_PENDING_TRIGGERED',
  NT_ORDER_PENDING_EXPIRED = 'NT_ORDER_PENDING_EXPIRED',
  NT_ORDER_PENDING_DELETED = 'NT_ORDER_PENDING_DELETED',
  NT_FCM_ORDER_PENDING_TRIGGERED = 'NT_FCM_ORDER_PENDING_TRIGGERED',
  NT_FCM_ORDER_PENDING_EXPIRED = 'NT_FCM_ORDER_PENDING_EXPIRED',
  NT_ORDER_CLOSE = 'NT_ORDER_CLOSE',
  NT_ORDER_TPSL_CLOSE = 'NT_ORDER_TPSL_CLOSE',
  NT_ORDER_TPSL_FCM_CLOSE = 'NT_ORDER_TPSL_FCM_CLOSE',
  NT_MARGIN_CALL = 'NT_MARGIN_CALL',
  NT_MARGIN_STOP_OUT = 'NT_MARGIN_STOP_OUT',
  NT_FCM_MARGIN_CALL = 'NT_FCM_MARGIN_CALL',
  NT_FCM_MARGIN_STOP_OUT = 'NT_FCM_MARGIN_STOP_OUT',
  NT_CALENDAR_CATEGORY = 'NT_CALENDAR_CATEGORY',
  NT_CALENDAR_COUNTRY = 'NT_CALENDAR_COUNTRY',
  NT_CALENDAR_EVENT = 'NT_CALENDAR_EVENT',
  NT_FCM_CALENDAR = 'NT_FCM_CALENDAR',
  NT_SYSTEM_SECURITY = 'NT_SYSTEM_SECURITY',
  NT_FCM_SYSTEM_SECURITY = 'NT_FCM_SYSTEM_SECURITY',
  NT_SIGNAL_EVENT = 'NT_SIGNAL_EVENT',
  NT_FCM_SIGNAL_EVENT = 'NT_FCM_SIGNAL_EVENT',
  NT_ACCOUNT_CANCEL_REQUEST = 'NT_ACCOUNT_CANCEL_REQUEST',
  NT_ROOT_ADMIN_DASHBOARD_SUMMARY = 'NT_ROOT_ADMIN_DASHBOARD_SUMMARY',
  NT_DEMO_ACCOUNT_CREATION = 'NT_DEMO_ACCOUNT_CREATION',
  NT_KICK_USER = 'NT_KICK_USER',
  NT_EXPERIENCE_DEMO_ACCOUNT_CREATION = 'NT_EXPERIENCE_DEMO_ACCOUNT_CREATION',
  NT_EXPERIENCE_RESET_PASSWORD = 'NT_EXPERIENCE_RESET_PASSWORD',
  NT_EXPERIENCE_DEMO_ACCOUNT_INTEREST = 'NT_EXPERIENCE_DEMO_ACCOUNT_INTEREST',
  NT_ORDER_HORIZON_EXECUTION_REPORT = 'NT_ORDER_HORIZON_EXECUTION_REPORT',
  NT_ORDER_HORIZON_REJECTED_ORDER = 'NT_ORDER_HORIZON_REJECTED_ORDER',
  NT_CTD_PNDG_ORD_SUBMITTED = 'NT_CTD_PNDG_ORD_SUBMITTED',
  NT_CTD_ORD_EXECUTED = 'NT_CTD_ORD_EXECUTED',
  NT_CTD_ORD_REJECTED = 'NT_CTD_ORD_REJECTED',
  NT_CTD_PNDG_ORD_DELETED = 'NT_CTD_PNDG_ORD_DELETED',
  NT_CTD_ORD_TPSL_EXECUTED = 'NT_CTD_ORD_TPSL_EXECUTED' // Centroid Edit Open Position
}

/** MEX Horizon */
export enum EHorizonExecuteType {
  NEW = 'NEW', // '0'
  PARTIAL_FILL = 'PARTIAL_FILL', // '1'
  FILL = 'FILL', // '2'
  DONE_FOR_DAY = 'DONE_FOR_DAY', // '3'
  CANCELED = 'CANCELED', // '4'
  REPLACED = 'REPLACED', // '5'
  PENDING_CANCEL = 'PENDING_CANCEL', // '6'
  STOPPED = 'STOPPED', // '7'
  REJECTED = 'REJECTED', // '8'
  SUSPENDED = 'SUSPENDED', // '9'
  PENDING_NEW = 'PENDING_NEW', // 'A'
  CALCULATED = 'CALCULATED', // 'B'
  EXPIRED = 'EXPIRED', // 'C'
  RESTATED = 'RESTATED', // 'D'
  PENDING_REPLACE = 'PENDING_REPLACE', // 'E'
  TRADE = 'TRADE', // 'F'
  TRADE_CORRECT = 'TRADE_CORRECT', // 'G'
  TRADE_CANCEL = 'TRADE_CANCEL', // 'H'
  ORDER_STATUS = 'ORDER_STATUS', // 'I'
  TRADE_IN_A_CLEARING_HOLD = 'TRADE_IN_A_CLEARING_HOLD', // 'J'
  TRADE_HAS_BEEN_RELEASED_TO_CLEARING = 'TRADE_HAS_BEEN_RELEASED_TO_CLEARING', // 'K'
  TRIGGERED_OR_ACTIVATED_BY_SYSTEM = 'TRIGGERED_OR_ACTIVATED_BY_SYSTEM' // 'L'
}

export enum EHorizonOrderStatus {
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED',
  DELETED = 'DELETED',
  CREDITED = 'CREDITED',
  NEW = 'NEW', // 0
  PARTIALLY_FILLED = 'PARTIALLY_FILLED', // 1
  FILLED = 'FILLED', // 2
  DONE_FOR_DAY = 'DONE_FOR_DAY', // 3
  CANCELED = 'CANCELED', // 4
  REPLACED = 'REPLACED', // 5
  PENDING_CANCEL = 'PENDING_CANCEL', // 6
  STOPPED = 'STOPPED', // 7
  REJECTED = 'REJECTED', // 8
  SUSPENDED = 'SUSPENDED', // 9
  PENDING_NEW = 'PENDING_NEW', // 10
  CALCULATED = 'CALCULATED', // 11
  ACCEPTED_FOR_BIDDING = 'ACCEPTED_FOR_BIDDING', // 13
  PENDING_REPLACE = 'PENDING_REPLACE' // 14,
}
